"use strict";

var _classCallCheck = require("C:/Users/Lenovo/Documents/part-time/tutee/tutee-resume-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("C:/Users/Lenovo/Documents/part-time/tutee/tutee-resume-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("C:/Users/Lenovo/Documents/part-time/tutee/tutee-resume-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("C:/Users/Lenovo/Documents/part-time/tutee/tutee-resume-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("C:/Users/Lenovo/Documents/part-time/tutee/tutee-resume-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:/Users/Lenovo/Documents/part-time/tutee/tutee-resume-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _wrapNativeSuper = require("C:/Users/Lenovo/Documents/part-time/tutee/tutee-resume-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _regeneratorRuntime = require("C:/Users/Lenovo/Documents/part-time/tutee/tutee-resume-app/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("C:/Users/Lenovo/Documents/part-time/tutee/tutee-resume-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _toArray = require("C:/Users/Lenovo/Documents/part-time/tutee/tutee-resume-app/node_modules/@babel/runtime/helpers/toArray");

var _slicedToArray = require("C:/Users/Lenovo/Documents/part-time/tutee/tutee-resume-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _defineProperty = require("C:/Users/Lenovo/Documents/part-time/tutee/tutee-resume-app/node_modules/@babel/runtime/helpers/defineProperty");

var _asyncToGenerator = require("C:/Users/Lenovo/Documents/part-time/tutee/tutee-resume-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Copyright 2018-2020 the Deno authors. All rights reserved. MIT license.
// This is a specialised implementation of a System module loader.

"use strict"; // @ts-nocheck

/* eslint-disable */


var System, _instantiate;

(function () {
  var r = new Map();
  System = {
    register: function register(id, d, f) {
      r.set(id, {
        d: d,
        f: f,
        exp: {}
      });
    }
  };

  function dI(_x, _x2) {
    return _dI.apply(this, arguments);
  }

  function _dI() {
    _dI = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(mid, src) {
      var id, _id$split$reverse, _id$split$reverse2, o, ia, _src$split$reverse, _src$split$reverse2, sa, oa, s, i;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              id = mid.replace(/\.\w+$/i, "");

              if (!id.includes("./")) {
                _context.next = 18;
                break;
              }

              _id$split$reverse = id.split("/").reverse(), _id$split$reverse2 = _toArray(_id$split$reverse), o = _id$split$reverse2[0], ia = _id$split$reverse2.slice(1), _src$split$reverse = src.split("/").reverse(), _src$split$reverse2 = _toArray(_src$split$reverse), sa = _src$split$reverse2.slice(1), oa = [o];
              s = 0;

            case 4:
              if (!(i = ia.shift())) {
                _context.next = 16;
                break;
              }

              if (!(i === "..")) {
                _context.next = 9;
                break;
              }

              s++;
              _context.next = 14;
              break;

            case 9:
              if (!(i === ".")) {
                _context.next = 13;
                break;
              }

              return _context.abrupt("break", 16);

            case 13:
              oa.push(i);

            case 14:
              _context.next = 4;
              break;

            case 16:
              if (s < sa.length) oa.push.apply(oa, _toConsumableArray(sa.slice(s)));
              id = oa.reverse().join("/");

            case 18:
              return _context.abrupt("return", r.has(id) ? gExpA(id) : Promise.resolve().then(function () {
                return require(mid);
              }));

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _dI.apply(this, arguments);
  }

  function gC(id, main) {
    return {
      id: id,
      import: function _import(m) {
        return dI(m, id);
      },
      meta: {
        url: id,
        main: main
      }
    };
  }

  function gE(exp) {
    return function (id, v) {
      v = typeof id === "string" ? _defineProperty({}, id, v) : id;

      for (var _i = 0, _Object$entries = Object.entries(v); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            _id = _Object$entries$_i[0],
            value = _Object$entries$_i[1];

        Object.defineProperty(exp, _id, {
          value: value,
          writable: true,
          enumerable: true
        });
      }
    };
  }

  function rF(main) {
    var _iterator = _createForOfIteratorHelper(r.entries()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
            id = _step$value[0],
            m = _step$value[1];

        var f = m.f,
            exp = m.exp;

        var _f = f(gE(exp), gC(id, id === main)),
            e = _f.execute,
            s = _f.setters;

        delete m.f;
        m.e = e;
        m.s = s;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  function gExpA(_x3) {
    return _gExpA.apply(this, arguments);
  }

  function _gExpA() {
    _gExpA = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
      var m, d, e, s, i, _r;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (r.has(id)) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              m = r.get(id);

              if (!m.s) {
                _context2.next = 22;
                break;
              }

              d = m.d, e = m.e, s = m.s;
              delete m.s;
              delete m.e;
              i = 0;

            case 8:
              if (!(i < s.length)) {
                _context2.next = 18;
                break;
              }

              _context2.t0 = s;
              _context2.t1 = i;
              _context2.next = 13;
              return gExpA(d[i]);

            case 13:
              _context2.t2 = _context2.sent;

              _context2.t0[_context2.t1].call(_context2.t0, _context2.t2);

            case 15:
              i++;
              _context2.next = 8;
              break;

            case 18:
              _r = e();

              if (!_r) {
                _context2.next = 22;
                break;
              }

              _context2.next = 22;
              return _r;

            case 22:
              return _context2.abrupt("return", m.exp);

            case 23:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _gExpA.apply(this, arguments);
  }

  function gExp(id) {
    if (!r.has(id)) return;
    var m = r.get(id);

    if (m.s) {
      var d = m.d,
          e = m.e,
          s = m.s;
      delete m.s;
      delete m.e;

      for (var i = 0; i < s.length; i++) {
        s[i](gExp(d[i]));
      }

      e();
    }

    return m.exp;
  }

  _instantiate = function __instantiate(m, a) {
    System = _instantiate = undefined;
    rF(m);
    return a ? gExpA(m) : gExp(m);
  };
})();

System.register("version", [], function (exports_1, context_1) {
  "use strict";

  var __moduleName = context_1 && context_1.id;

  return {
    setters: [],
    execute: function execute() {
      exports_1("default", '3.2.3');
    }
  };
});
System.register("mod", ["version"], function (exports_2, context_2) {
  "use strict";

  var version_ts_1, DEFAULT_UUID_LENGTH, DIGIT_FIRST_ASCII, DIGIT_LAST_ASCII, ALPHA_LOWER_FIRST_ASCII, ALPHA_LOWER_LAST_ASCII, ALPHA_UPPER_FIRST_ASCII, ALPHA_UPPER_LAST_ASCII, DICT_RANGES, DEFAULT_OPTIONS, ShortUniqueId;

  var __moduleName = context_2 && context_2.id;

  return {
    setters: [function (version_ts_1_1) {
      version_ts_1 = version_ts_1_1;
    }],
    execute: function execute() {
      DEFAULT_UUID_LENGTH = 6;
      DIGIT_FIRST_ASCII = 48;
      DIGIT_LAST_ASCII = 58;
      ALPHA_LOWER_FIRST_ASCII = 97;
      ALPHA_LOWER_LAST_ASCII = 123;
      ALPHA_UPPER_FIRST_ASCII = 65;
      ALPHA_UPPER_LAST_ASCII = 91;
      DICT_RANGES = {
        digits: [DIGIT_FIRST_ASCII, DIGIT_LAST_ASCII],
        lowerCase: [ALPHA_LOWER_FIRST_ASCII, ALPHA_LOWER_LAST_ASCII],
        upperCase: [ALPHA_UPPER_FIRST_ASCII, ALPHA_UPPER_LAST_ASCII]
      };
      DEFAULT_OPTIONS = {
        dictionary: [],
        shuffle: true,
        debug: false,
        length: DEFAULT_UUID_LENGTH
      };

      ShortUniqueId = /*#__PURE__*/function (_Function) {
        _inherits(ShortUniqueId, _Function);

        var _super = _createSuper(ShortUniqueId);

        function ShortUniqueId() {
          var _this;

          var argOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          _classCallCheck(this, ShortUniqueId);

          _this = _super.call(this);
          _this.dictIndex = 0;
          _this.dictRange = [];
          _this.lowerBound = 0;
          _this.upperBound = 0;
          _this.dictLength = 0;

          var options = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), argOptions);

          _this.counter = 0;
          _this.debug = false;
          _this.dict = [];
          _this.version = version_ts_1.default;
          var userDict = options.dictionary,
              shuffle = options.shuffle,
              length = options.length;
          _this.uuidLength = length;

          if (userDict && userDict.length > 1) {
            _this.setDictionary(userDict);
          } else {
            var i;
            _this.dictIndex = i = 0;
            Object.keys(DICT_RANGES).forEach(function (rangeType) {
              var rangeTypeKey = rangeType;
              _this.dictRange = DICT_RANGES[rangeTypeKey];
              _this.lowerBound = _this.dictRange[0];
              _this.upperBound = _this.dictRange[1];

              for (_this.dictIndex = i = _this.lowerBound; _this.lowerBound <= _this.upperBound ? i < _this.upperBound : i > _this.upperBound; _this.dictIndex = _this.lowerBound <= _this.upperBound ? i += 1 : i -= 1) {
                _this.dict.push(String.fromCharCode(_this.dictIndex));
              }
            });
          }

          if (shuffle) {
            var PROBABILITY = 0.5;

            _this.setDictionary(_this.dict.sort(function () {
              return Math.random() - PROBABILITY;
            }));
          } else {
            _this.setDictionary(_this.dict);
          }

          _this.debug = options.debug;

          _this.log(_this.dict);

          _this.log("Generator instantiated with Dictionary Size ".concat(_this.dictLength));

          return _possibleConstructorReturn(_this, new Proxy(_assertThisInitialized(_this), {
            apply: function apply(target, that, args) {
              var _this2;

              return (_this2 = _this).randomUUID.apply(_this2, _toConsumableArray(args));
            }
          }));
        }

        _createClass(ShortUniqueId, [{
          key: "log",
          value: function log() {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            var finalArgs = [].concat(args);
            finalArgs[0] = "[short-unique-id] ".concat(args[0]);

            if (this.debug === true) {
              if (typeof console !== 'undefined' && console !== null) {
                var _console;

                return (_console = console).log.apply(_console, _toConsumableArray(finalArgs));
              }
            }
          }
        }, {
          key: "setDictionary",
          value: function setDictionary(dictionary) {
            this.dict = dictionary;
            this.dictLength = this.dict.length;
            this.counter = 0;
          }
        }, {
          key: "seq",
          value: function seq() {
            return this.sequentialUUID();
          }
        }, {
          key: "sequentialUUID",
          value: function sequentialUUID() {
            var counterDiv;
            var counterRem;
            var id = '';
            counterDiv = this.counter;

            while (true) {
              counterRem = counterDiv % this.dictLength;
              counterDiv = Math.trunc(counterDiv / this.dictLength);
              id += this.dict[counterRem];

              if (counterDiv === 0) {
                break;
              }
            }

            this.counter += 1;
            return id;
          }
        }, {
          key: "randomUUID",
          value: function randomUUID() {
            var uuidLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.uuidLength || DEFAULT_UUID_LENGTH;
            var id;
            var randomPartIdx;
            var j;
            var idIndex;

            if (uuidLength === null || typeof uuidLength === 'undefined' || uuidLength < 1) {
              throw new Error('Invalid UUID Length Provided');
            }

            id = '';

            for (idIndex = j = 0; 0 <= uuidLength ? j < uuidLength : j > uuidLength; idIndex = 0 <= uuidLength ? j += 1 : j -= 1) {
              randomPartIdx = parseInt((Math.random() * this.dictLength).toFixed(0), 10) % this.dictLength;
              id += this.dict[randomPartIdx];
            }

            return id;
          }
        }, {
          key: "availableUUIDs",
          value: function availableUUIDs() {
            var uuidLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.uuidLength;
            return parseFloat(Math.pow(_toConsumableArray(new Set(this.dict)).length, uuidLength).toFixed(0));
          }
        }, {
          key: "approxMaxBeforeCollision",
          value: function approxMaxBeforeCollision() {
            var rounds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.availableUUIDs(this.uuidLength);
            return parseFloat(Math.sqrt(Math.PI / 2 * rounds).toFixed(20));
          }
        }, {
          key: "collisionProbability",
          value: function collisionProbability() {
            var rounds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.availableUUIDs(this.uuidLength);
            var uuidLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.uuidLength;
            return parseFloat((this.approxMaxBeforeCollision(rounds) / this.availableUUIDs(uuidLength)).toFixed(20));
          }
        }, {
          key: "uniqueness",
          value: function uniqueness() {
            var rounds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.availableUUIDs(this.uuidLength);
            var score = parseFloat((1 - this.approxMaxBeforeCollision(rounds) / rounds).toFixed(20));
            return score > 1 ? 1 : score < 0 ? 0 : score;
          }
        }, {
          key: "getVersion",
          value: function getVersion() {
            return this.version;
          }
        }]);

        return ShortUniqueId;
      }( /*#__PURE__*/_wrapNativeSuper(Function));

      exports_2("default", ShortUniqueId);
    }
  };
});

var __exp = _instantiate("mod", false);

exports.default = __exp["default"];